"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageOptionTXBJ = void 0;
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var crumbs_1 = require("../crumbs");
var txbj_table_1 = require("../quotetable/txbj_table");
require("./option.less");
var quote_1 = require("../../modules/quote");
var qiquantab_1 = require("./shared/qiquantab");
var txbj_table_2 = require("../qihuotable/txbj_table");
var tablepage_config_1 = require("../quotetable/tablepage_config");
var tablepage_config_2 = require("../qihuotable/tablepage_config");
var web_1 = require("../../modules/qihuo/web");
var lodash_1 = require("lodash");
var delaytips_1 = require("./shared/delaytips");
// 中金三个期货接口的报价需要展示延时提示
var qihuobj = [
    'options_zjcffex_txbj',
    'options_zjcffex_mo_txbj',
    'options_zjcffex_ho_txbj'
];
/**
 * 期权t型报价
 */
function PageOptionTXBJ() {
    var location = (0, react_router_dom_1.useLocation)();
    var hash = location.hash.toLowerCase();
    if (hash.substring(0, 1) == '#') {
        hash = hash.substring(1);
    }
    // console.info(hash)
    return (react_1.default.createElement("div", { className: "txbj" },
        qihuobj.indexOf(hash) > -1 && react_1.default.createElement(crumbs_1.CrumbsNoRefresh, { insertRight: (0, delaytips_1.DelayMin15Tip)() }),
        qihuobj.indexOf(hash) < 0 && react_1.default.createElement(crumbs_1.CrumbsWithRefresh, null),
        react_1.default.createElement(qiquantab_1.CustomQiQuanMainTab2, null),
        qihuobj.indexOf(hash) < 0 && react_1.default.createElement(QuoteTxbjBox, { hash: hash }),
        qihuobj.indexOf(hash) > -1 && react_1.default.createElement(QihuoTxbjBox, { hash: hash })));
}
exports.PageOptionTXBJ = PageOptionTXBJ;
/**
 * 行情接口的报价
 * @returns
 */
function QuoteTxbjBox(props) {
    // console.info(111, props.hash)
    var _this = this;
    var _a = (0, react_1.useState)(""), time = _a[0], setTime = _a[1];
    var _b = (0, react_1.useState)([]), timeList = _b[0], setTimeList = _b[1];
    var hashtable_config = tablepage_config_1.hashtable[props.hash];
    (0, react_1.useEffect)(function () {
        ;
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var times, default_time;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, quote_1.getTXBJTimeList)(hashtable_config.fs)];
                    case 1:
                        times = _a.sent();
                        default_time = getQuoteDefaultTime(props.hash, times);
                        setTime(default_time);
                        setTimeList(times);
                        return [2 /*return*/];
                }
            });
        }); })();
    }, [props.hash]);
    /** 时间切换 */
    var selectSettime = function (str) {
        setTime(str);
        // localStorage.setItem('time_' + props.hash, str)
    };
    if (!time)
        return react_1.default.createElement(react_1.default.Fragment, null);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(TxbjFilterHead, { type: 'quote', callback: selectSettime, timevalue: time, timelist: timeList, name: hashtable_config.name }),
        react_1.default.createElement(txbj_table_1.QuoteTXBJTable, { time: time, first_sort_dir: 0 })));
}
/**
 * 期货接口的报价
 * @returns
 */
function QihuoTxbjBox(props) {
    var _this = this;
    var thishash = (0, react_1.useRef)(props.hash);
    var _a = (0, react_1.useState)(""), selecttime = _a[0], setSelectTime = _a[1];
    var _b = (0, react_1.useState)([]), timeList = _b[0], setTimeList = _b[1];
    var _c = (0, react_1.useState)({ result: [], count: 0 }), datas = _c[0], setDatas = _c[1];
    var hashtable_config = tablepage_config_2.hashqhtable[props.hash];
    var tableitem = (0, lodash_1.cloneDeep)(tablepage_config_2.tableqihuoitemconfig[hashtable_config.table]);
    var default_sort = (0, txbj_table_2.getQHDefaultSort)(tableitem); //默认排序 
    var _d = (0, react_1.useState)(default_sort.cp), cp = _d[0], SetCp = _d[1];
    var _e = (0, react_1.useState)(default_sort.orderby), sortitem = _e[0], SetSortItem = _e[1];
    var _f = (0, react_1.useState)(default_sort.sort_direct), sortdirect = _f[0], SetSortDirect = _f[1];
    var _g = (0, react_1.useState)(1), nowindex = _g[0], SetNowIndex = _g[1];
    var pagesize = 20;
    (0, react_1.useEffect)(function () {
        if (props.hash != thishash.current) {
            SetNowIndex(1);
            SetSortItem(default_sort.orderby);
        }
        thishash.current = props.hash;
        getData();
    }, [props.hash, cp, sortitem, sortdirect, nowindex, selecttime]);
    var secid = hashtable_config.code || "";
    var getData = function () { return __awaiter(_this, void 0, void 0, function () {
        var qihuodata, dates, default_time;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, web_1.searchQiHuoListWithOptionTXBJ)(secid, cp, selecttime, sortitem, nowindex, pagesize, sortdirect)];
                case 1:
                    qihuodata = _a.sent();
                    dates = formatTXBJTime(qihuodata === null || qihuodata === void 0 ? void 0 : qihuodata.date) || [];
                    setTimeList(dates);
                    default_time = getQihuoDefaultTime(props.hash, dates, selecttime);
                    // console.log(default_time)
                    setSelectTime(default_time);
                    // setSelectTime(dates?.[0]?.date.toString() || "") // 默认选中第一个
                    setDatas(qihuodata);
                    return [2 /*return*/];
            }
        });
    }); };
    var changeSort = function (tosortitem) {
        var orderby = tosortitem.split(",")[1];
        SetSortItem(orderby);
        SetCp(tosortitem.split(",")[0]);
        if (sortitem == orderby) {
            if (sortdirect == 'asc') {
                SetSortDirect('desc');
            }
            else {
                SetSortDirect('asc');
            }
        }
        else {
            SetSortDirect('desc');
        }
        SetNowIndex(1);
    };
    var selectSettime = function (str) {
        setSelectTime(str);
        SetNowIndex(1);
        // localStorage.setItem('time_' + props.hash, str)
    };
    if (!datas) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(TxbjFilterHead, { type: "qihuo", callback: selectSettime, timevalue: selecttime, timelist: timeList }),
        react_1.default.createElement(txbj_table_2.QiQuanTXBJTable, { nowindex: nowindex, pagesize: pagesize, tableitem: tableitem, qihuodata: datas, sortdirect: sortdirect, sortitem: sortitem, changeSort: changeSort, onChangePager: SetNowIndex })));
}
/**
 * 时间筛选
 * @returns
 */
function TxbjFilterHead(props) {
    // console.info(props.timevalue)
    // useEffect(()=>{},[props.timevalue])
    var onchangeTime = function (e) {
        var time = e.target.value;
        props.callback && props.callback(time);
    };
    return (react_1.default.createElement("div", { className: "txbj_header" },
        react_1.default.createElement("div", { className: "inner" },
            react_1.default.createElement("div", { className: "item tx_tit" },
                props.name,
                "\u8BA4\u8D2D\u671F\u6743"),
            react_1.default.createElement("div", { className: "item tx_sel" },
                react_1.default.createElement("select", { className: "tx_dete", onChange: onchangeTime, value: props.timevalue }, props.timelist && props.timelist.map(function (v, i) {
                    var value = props.type == 'quote' ? (v.date.toString()).substring(0, 6) : v.date;
                    return react_1.default.createElement("option", { key: v.date, value: value }, dealTXBJTime(v.date, v.days));
                }))),
            react_1.default.createElement("div", { className: "item tx_tit" },
                props.name,
                "\u8BA4\u6CBD\u671F\u6743"))));
}
/**
 * 下拉时间格式化
 * @param date
 * @param days
 * @returns
 */
function dealTXBJTime(date, days) {
    if (date > 0 && date.toString().length > 7) {
        var datestr = date.toString();
        return "".concat(datestr.substring(0, 4), "\u5E74").concat(datestr.substring(4, 6), "\u6708(").concat(days, ")\u5929");
    }
    return date;
}
/**
 * 格式化期货接口时间
 * @param list
 * @returns
 */
function formatTXBJTime(list) {
    if (list == undefined || list.length == 0)
        return [];
    return list.map((function (v) {
        return {
            days: v.remainDay,
            date: v.date
        };
    }));
}
/**
 * 获取默认时间
 * @param hash
 */
function getQuoteDefaultTime(hash, list) {
    // let cache_name = 'time_' + hash
    // let cache_time = localStorage.getItem(cache_name) || "";
    var _a, _b;
    var cache_time = '';
    // if (!cache_time) {
    cache_time = (_b = ((_a = list === null || list === void 0 ? void 0 : list[0]) === null || _a === void 0 ? void 0 : _a.date.toString())) === null || _b === void 0 ? void 0 : _b.substring(0, 6);
    // localStorage.setItem(cache_name, cache_time)
    return cache_time;
    // }
    // console.log(cache_time)
    // return cache_time
}
/**
 * 期货默认时间
 * @param hash
 * @param list
 * @returns
 */
function getQihuoDefaultTime(hash, list, selecttime) {
    // let cache_name = 'time_' + hash
    // let cache_time = localStorage.getItem(cache_name) || "";
    // console.info(list, selecttime)
    var _a;
    if (list.some(function (v) { return v.date.toString() == selecttime; }))
        return selecttime;
    var cache_time = '';
    // if (!cache_time) {
    cache_time = ((_a = list === null || list === void 0 ? void 0 : list[0]) === null || _a === void 0 ? void 0 : _a.date.toString());
    // localStorage.setItem(cache_name, cache_time)
    return cache_time;
    // }
    // // console.log(cache_time)
    // return cache_time
}
